module.exports = __webpack_public_path__ + "static/media/cV3NnsfpA1Q.570b3452.jpg";